import { usePusher } from '@harelpls/use-pusher'
import { App } from 'antd'
import debug from 'debug'
import { FC, useEffect, useState } from 'react'
import { useAppSelector } from 'store'

const log = debug('PushAuthenticationListener')

export const PushAuthenticationListener: FC = () => {
  const isAuthenticated = useAppSelector(state => state.auth.authenticated)
  const { client } = usePusher()
  const [done, setDone] = useState(false)
  const { message } = App.useApp()

  useEffect(() => {
    if (!client) {
      return
    }

    const connected = () => {
      void message.success('Connected to Push Service')
    }
    const disconnected = () => {
      void message.warning('Disconnected from Push Service')
    }

    client.bind('connected', connected)
    client.bind('disconnected', disconnected)

    return () => {
      client.unbind('connected', connected)
      client.unbind('disconnected', disconnected)
    }
  }, [client])

  useEffect(() => {
    if (!client) {
      return
    }

    if (isAuthenticated) {
      log('start signin')
      client.signin()
      setDone(true)

      client.user.signin()
      void client.user.signinDonePromise
        .then(() => {
          if (client.user.user_data) {
            log('sign in done')
          } else {
            log('failed to sign in')
          }
        })
        .catch((e) => {
          log('error during sign in: %o', e)
        })
    }
  }, [client, isAuthenticated])

  useEffect(() => {
    if (!client || !done || isAuthenticated) {
      return
    }

    setDone(false)

    log('disconnect all channels')
    client.disconnect()
    client.connect()
  }, [client, isAuthenticated, done])

  return null
}
